import { render, staticRenderFns } from "./AgencyItem.vue?vue&type=template&id=3a8b03cc&scoped=true&"
import script from "./AgencyItem.vue?vue&type=script&lang=js&"
export * from "./AgencyItem.vue?vue&type=script&lang=js&"
import style0 from "./AgencyItem.vue?vue&type=style&index=0&id=3a8b03cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b03cc",
  null
  
)

export default component.exports